import DateHelper from '../Utility/DateHelper';

export function restoreNumber(value: any, defaultValue?: number): number {
    if (
        (value === undefined || value === null || isNaN(value)) &&
        defaultValue !== undefined
    ) {
        return defaultValue;
    } else if (typeof value === 'string') {
        return Number(parseInt(value));
    } else {
        return Number(value);
    }
}

export function restoreBoolean(value: any, defaultValue?: boolean): boolean {
    if (value === 0 || value === 1) {
        return Boolean(value);
    } else if (typeof value === 'string') {
        return Boolean(parseInt(value));
    } else if (defaultValue !== undefined) {
        return defaultValue;
    }

    return null;
}

export function restoreString(value: any, defaultValue?: string): string {
    if ((value === undefined || value === null) && defaultValue !== undefined) {
        return defaultValue;
    } else {
        return String(value);
    }
}

export function restoreStringifiedArray<T>(
    value: any,
    defaultValue: T[] = []
): T[] {
    if (value && typeof value === 'string') {
        try {
            return JSON.parse(value);
        } catch (e) {}
    }

    return defaultValue;
}

export function restoreStringifiedObject<T extends {}>(
    value: any,
    defaultValue?: T
): T {
    if (value && typeof value === 'string') {
        try {
            return JSON.parse(value);
        } catch (e) {}
    }

    return defaultValue;
}

export function restoreDateString(value: any): string {
    if (
        value !== undefined &&
        value !== false &&
        value !== null &&
        value !== 'null' &&
        value !== 0 &&
        value !== '0' &&
        typeof value === 'string' &&
        !isNaN(Date.parse(value))
    ) {
        return value;
    }

    return null;
}

export function restoreDate(value: any): Date {
    if (
        value === undefined ||
        value === false ||
        value === null ||
        value === 'null' ||
        value === 0 ||
        value === '0'
    ) {
        return null;
    }

    let date: Date | null = null;

    if (typeof value === 'string') {
        date = isNaN(Date.parse(value)) ? isNaN(parseInt(value)) ? null : new Date(parseInt(value)) : new Date(value);
    }

    if (typeof value === 'number') {
        date = new Date(value);
    }

    if (date && DateHelper.now.getTime() + DateHelper.Day > date.getTime()) {
        return date;
    } else {
        return null;
    }
}
export function dateToString(date: Date): string {
    return date === null || date === undefined ? null : date.toString();
}
